// removed by extract-text-webpack-plugin
module.exports = {"plot-list":"plot-list__plot-list","plot-list-loading":"plot-list__plot-list-loading","load-more":"plot-list__load-more"};


//////////////////
// WEBPACK FOOTER
// ./src/components/plot-list/plot-list.scss
// module id = 1230
// module chunks = 0